import i18n from 'config/i18n';
import { getLocale } from 'utils/date';
import { Option } from 'components/shared/ControlledFields/ControlledSelect';

const t = i18n.getFixedT(getLocale(), 'common');

export const masterDataApplicationOptions = [
  {
    value: 'SDB_PLANNING',
    label: t('activityPlanningSettings.application_providers.SDB_PLANNING')
  },
  {
    id: 'SDB_ECD',
    label: t('activityPlanningSettings.application_providers.SDB_ECD')
  }
] as Option[];

export const careReceiverNameFormatOptions: Option[] = [
  {
    value: 'SOURCE_DISPLAY_NAME',
    label: t('careReceiverNameFormatSettings.options.SOURCE_DISPLAY_NAME')
  },
  {
    value: 'LASTNAME_GIVENNAME',
    label: t('careReceiverNameFormatSettings.options.LASTNAME_GIVENNAME')
  },
  {
    value: 'GIVENNAME_LASTNAME',
    label: t('careReceiverNameFormatSettings.options.GIVENNAME_LASTNAME')
  },
  {
    value: 'TITLE_GIVENNAME_LASTNAME',
    label: t('careReceiverNameFormatSettings.options.TITLE_GIVENNAME_LASTNAME')
  },
  {
    value: 'INITIALS_LASTNAME',
    label: t('careReceiverNameFormatSettings.options.INITIALS_LASTNAME')
  },
  {
    value: 'TITLE_INITIALS_LASTNAME',
    label: t('careReceiverNameFormatSettings.options.TITLE_INITIALS_LASTNAME')
  },
  {
    value: 'LASTNAME_INITIALS',
    label: t('careReceiverNameFormatSettings.options.LASTNAME_INITIALS')
  }
];

export const workforceManagementApplicationOptions = [
  {
    value: 'SDB_ACTIVITY_PLANNING',
    label: t(
      'activityPlanningSettings.application_providers.SDB_ACTIVITY_PLANNING'
    )
  },
  {
    value: 'SDB_PLANNING',
    label: t('activityPlanningSettings.application_providers.SDB_PLANNING')
  },
  {
    value: 'INTUS',
    label: t('activityPlanningSettings.application_providers.INTUS')
  },
  {
    value: 'SDB_ECD',
    label: t('activityPlanningSettings.application_providers.SDB_ECD')
  }
] as Option[];
